import Vue from 'vue'
import db from '@/api/db'
import Router from 'vue-router'
import homeIndex from '@/components/Home/home_index'
import login from '@/components/Login/login_index'
import unitLogin from '@/components/Login/unit_login'
import aboutIndex from '@/components/About/about_index'
import pubIndex from '@/components/Public/public_index'
import pubDetails from '@/components/News/public_news_details'

import projectIndex from '@/components/Project/project_index'
import infoIndex from '@/components/Info/info_index'
import unitRegister from '@/components/Unit/register'
import projectDetails from '@/components/Project_details/details_index'
import donationIndex from '@/components/Donation/donation_index'
import joinIndex from '@/components/Join/join_index'
import applyIndex from '@/components/Apply/apply_index'
import branchIndex from '@/components/Branch/branch_index'
import branchApply from '@/components/Branch/branch_apply'
import volunteerApply from '@/components/Volunteer/volunteer_apply'
import councilDetails from '@/components/Council/council_details'


//单位系统管理端相关路由
import comProjectLaunch from '@/components/Hospital/comproject/launch/list.vue' //公益项目事务代表立项列表
import comProjectAuditList from '@/components/Hospital/comproject/audit/list.vue' //公益项目事务代表审核立项列表

import hospitalBuildInfo from '@/components/Hospital/comproject/approval/info.vue' //公益项目立项
import hospitalBuildList from '@/components/Hospital/comproject/approval/list.vue' //公益项目立项列表
import hospitalComProjectList from '@/components/Hospital/comproject/info/list.vue' //公益项目列表
import hospitalProjectMediaList from '@/components/Hospital/comproject/info/media_list.vue' //公益项目媒体报告列表
import hospitalProjectReportList from '@/components/Hospital/comproject/info/report_list.vue' //公益项目阶段报告列表
import hospitalPaymentList from '@/components/Hospital/comproject/payment/list.vue' //公益项目结算列表

import comProDonation from '@/components/Hospital/comproject/donate/list.vue' //公益项目捐款列表



import comProjectApply from '@/components/Hospital/comproject/apply/list.vue' //公益项目救助花名册列表
import comProjectExports from '@/components/Hospital/comproject/apply/export.vue' //公益项目救助花名册导入


// import hospitalComProjectBudget from '@/components/Hospital/comproject/budget.vue' //公益回款管理信息
import hospitalComProjectInfo from '@/components/Hospital/comproject/info/info.vue' //公益项目详情
import hospitalProjectPayment from '@/components/Hospital/comproject/payment_info.vue' //公益项目捐款资料申请
import hospitalProjectPaymentList from '@/components/Hospital/comproject/payment_list.vue' //公益项目捐款资料列表
import comProEnd from '@/components/Hospital/comproject/end/list.vue' //公益合作项目结项列表


import hospitalUserManagementList from '@/components/Hospital/user/list.vue' // 执行机构端管理人员列表
import unitInfoSet from '@/components/Hospital/unit/info.vue' // 执行机构端单位信息管理


import cfProjectList from '@/components/Hospital/cfproject/info/list.vue' //众筹项目列表
import cfProjectInfo from '@/components/Hospital/cfproject/info/detail.vue' //众筹项目详情
import cfProAppropriation from '@/components/Hospital/cfproject/appropriation/list.vue' //众筹项目拨款申请列表  
import cfProAppropriationDo1 from '@/components/Hospital/cfproject/appropriation/info1.vue' //众筹项目拨款申请
import cfProApplyList from '@/components/Hospital/cfproject/apply/list.vue' //众筹项目救助列表
import cfProApplyVisit from '@/components/Hospital/cfproject/apply/visit_list.vue' //众筹项目信息提交走访记录
import cfProjectApplyInfo from '@/components/Hospital/cfproject/apply/detail.vue' //众筹项目救助列表详情



// import cfProSubmitAgreement from '@/components/Hospital/cfproject/agreement.vue' //众筹项目信息提交协议
import cfProSubmitMedia from '@/components/Hospital/cfproject/info/media.vue' //众筹项目信息提交媒体报告
import cfProSubmitReport from '@/components/Hospital/cfproject/report.vue' //众筹项目信息提交阶段性报告

// import cfProPaymentList from '@/components/Hospital/cfproject_payment/list.vue' //众筹项目捐款列表  
// import cfProPaymentAdd from '@/components/Hospital/cfproject_payment/add.vue' //众筹项目捐款列表新增
// import cfProPaymentEdit from '@/components/Hospital/cfproject_payment/edit.vue' //众筹项目捐款列表新增
import report from '@/components/Hospital/Report/list.vue' // 上报申请列表
import reportExports from '@/components/Hospital/Report/export.vue' // 上报申请列表
import reportEdit from '@/components/Hospital/Report/edit.vue' // 上报申请编辑

//新增项目新闻 ProjectNews
import projectNews from '@/components/ProjectNews/index' // 项目新闻详情

import orgList from '@/components/Public/public_partner.vue' // 合作伙伴
import orgLists from '@/components/Public/public_org.vue' // 研究机构
import unitList from '@/components/Public/public_unit.vue' //单位列表
import viewPage from '@/components/Public/view_page.vue' //单页预览

import friend from '@/friend.vue'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [{
      path: '/',
      name: 'homeIndex',
      component: homeIndex
    },
    {
      path: '/friend',
      name: 'friend',
      component: friend
    },
    {
      path: '/login',
      name: 'login',
      component: login
    },
    {
      path: '/unitLogin',
      name: 'unitLogin',
      component: unitLogin
    },
    {
      path: '/unitRegister',
      name: 'unitRegister',
      component: unitRegister
    },
    {
      path: '/aboutIndex',
      name: 'aboutIndex',
      component: aboutIndex
    },
    {
      path: '/councilDetails',
      name: 'councilDetails',
      component: councilDetails
    },
    {
      path: '/pubIndex',
      name: 'pubIndex',
      component: pubIndex
    },
    {
      path: '/pubDetails',
      name: 'pubDetails',
      component: pubDetails
    },
    {
      path: '/projectIndex',
      name: 'projectIndex',
      component: projectIndex
    },
    {
      path: '/infoIndex',
      name: 'infoIndex',
      component: infoIndex
    },
    {
      path: '/projectDetails',
      name: 'projectDetails',
      component: projectDetails
    },
    {
      path: '/donationIndex',
      name: 'donationIndex',
      component: donationIndex
    },
    {
      path: '/joinIndex',
      name: 'joinIndex',
      component: joinIndex
    },

    {
      path: '/volunteerApply',
      name: 'volunteerApply',
      component: volunteerApply
    },
    {
      path: '/applyIndex',
      name: 'applyIndex',
      component: applyIndex
    },
    {
      path: '/branchApply',
      name: 'branchApply',
      component: branchApply
    },
    {
      path: '/branchIndex',
      name: 'branchIndex',
      component: branchIndex
    },
    {
      path: '/projectNews',
      name: 'projectNews',
      component: projectNews
    },

    {
      path: '/orgList',
      name: 'orgList',
      component: orgList
    },

    {
      path: '/orgLists',
      name: 'orgLists',
      component: orgLists
    },

    {
      path: '/unitList',
      name: 'unitList',
      component: unitList
    },

    {
      path: '/viewPage',
      name: 'viewPage',
      component: viewPage
    },


    //单位系统端  type:1表示公益菜单 2表示众筹菜单 3表示both unitAuth:true表示需要登录
    {
      path: '/comProjectLaunch', //公益代表发起项目列表
      name: 'comProjectLaunch',
      meta: {
        unitAuth: true, // 添加登录验证（该页面需要登录）
        type: 1 //表示公益菜单
      },
      component: comProjectLaunch,
    },

    {
      path: '/comProjectAuditList', //公益代表立项审核列表
      name: 'comProjectAuditList',
      meta: {
        unitAuth: true, // 添加登录验证（该页面需要登录）
        type: 1 //表示公益菜单
      },
      component: comProjectAuditList,
    },

    {
      path: '/comProEnd', //公益代表立项审核列表
      name: 'comProEnd',
      meta: {
        unitAuth: true, // 添加登录验证（该页面需要登录）
        type: 1 //表示公益菜单
      },
      component: comProEnd,
    },

    {
      path: '/hospitalBuildInfo',
      name: 'hospitalBuildInfo',
      meta: {
        unitAuth: true, // 添加登录验证（该页面需要登录）
        type: 1 //表示公益菜单
      },
      component: hospitalBuildInfo,
    },
    {
      path: '/hospitalBuildList',
      name: 'hospitalBuildList',
      meta: {
        unitAuth: true, // 添加登录验证（该页面需要登录）
        type: 1 //表示公益菜单
      },
      component: hospitalBuildList,
    },
    // {
    //   path: '/hospitalComProjectBudget',
    //   name: 'hospitalComProjectBudget',
    //   meta: {
    //     unitAuth: true, // 添加登录验证（该页面需要登录）
    //     type: 1 //表示公益菜单
    //   },
    //   component: hospitalComProjectBudget,
    // },

    {
      path: '/comProjectApply',
      name: 'comProjectApply',
      meta: {
        unitAuth: true, // 添加登录验证（该页面需要登录）
        type: 1 //表示公益菜单
      },
      component: comProjectApply,
    },

    {
      path: '/comProjectExports',
      name: 'comProjectExports',
      meta: {
        unitAuth: true, // 添加登录验证（该页面需要登录）
        type: 1
      },
      component: comProjectExports,
    },

    // {
    //   path: '/comPublicApplyList',
    //   name: 'comPublicApplyList',
    //   meta: {
    //     unitAuth: true, // 添加登录验证（该页面需要登录）
    //     type:1//表示公益菜单
    //   },
    //   component:comPublicApplyList,
    // },
    // {
    //   path: '/comPublicApply',
    //   name: 'comPublicApply',
    //   meta: {
    //     unitAuth: true, // 添加登录验证（该页面需要登录）
    //     type: 1 //表示公益菜单
    //   },
    //   component: comPublicApply,
    // },
    // {
    //   path: '/comPublicApplyEdit',
    //   name: 'comPublicApplyEdit',
    //   meta: {
    //     unitAuth: true, // 添加登录验证（该页面需要登录）
    //     type: 1 //表示公益菜单
    //   },
    //   component: comPublicApplyEdit,
    // },
    {
      path: '/hospitalPaymentList',
      name: 'hospitalPaymentList',
      meta: {
        unitAuth: true, // 添加登录验证（该页面需要登录）
        type: 1 //表示公益菜单
      },
      component: hospitalPaymentList,
    },

    {
      path: '/comProDonation',
      name: 'comProDonation',
      meta: {
        unitAuth: true, // 添加登录验证（该页面需要登录）
        type: 1 //表示公益菜单
      },
      component: comProDonation,
    },

    {
      path: '/hospitalComProjectList',
      name: 'hospitalComProjectList',
      meta: {
        unitAuth: true, // 添加登录验证（该页面需要登录）
        type: 1 //表示公益菜单
      },
      component: hospitalComProjectList,
    },
    {
      path: '/hospitalProjectPayment',
      name: 'hospitalProjectPayment',
      meta: {
        unitAuth: true, // 添加登录验证（该页面需要登录）
        type: 1 //表示公益菜单
      },
      component: hospitalProjectPayment
    },
    {
      path: '/hospitalComProjectInfo',
      name: 'hospitalComProjectInfo',
      meta: {
        unitAuth: true, // 添加登录验证（该页面需要登录）
        type: 1 //表示公益菜单
      },
      component: hospitalComProjectInfo
    },
    {
      path: '/hospitalProjectPaymentList',
      name: 'hospitalProjectPaymentList',
      meta: {
        unitAuth: true, // 添加登录验证（该页面需要登录）
        type: 1 //表示公益菜单
      },
      component: hospitalProjectPaymentList
    },
    {
      path: '/hospitalProjectReportList',
      name: 'hospitalProjectReportList',
      meta: {
        unitAuth: true, // 添加登录验证（该页面需要登录）
        type: 1 //表示公益菜单
      },
      component: hospitalProjectReportList
    },
    {
      path: '/hospitalProjectMediaList',
      name: 'hospitalProjectMediaList',
      meta: {
        unitAuth: true, // 添加登录验证（该页面需要登录）
        type: 1 //表示公益菜单
      },
      component: hospitalProjectMediaList
    },


    { //执行机构端人员管理
      path: '/hospitalUserManagementList',
      name: 'hospitalUserManagementList',
      meta: {
        unitAuth: true, // 添加登录验证（该页面需要登录）
        type: 3 //表示公益菜单
      },
      component: hospitalUserManagementList
    },
    { //执行机构端单位信息管理
      path: '/unitInfoSet',
      name: 'unitInfoSet',
      meta: {
        unitAuth: true, // 添加登录验证（该页面需要登录）
        type: 3 //表示公益菜单
      },
      component: unitInfoSet
    },


    //众筹菜单
    {
      path: '/cfProjectList',
      name: 'cfProjectList',
      meta: {
        unitAuth: true, // 添加登录验证（该页面需要登录）
        type: 2 //表示众筹菜单
      },
      component: cfProjectList,
    },
    {
      path: '/cfProjectInfo',
      name: 'cfProjectInfo',
      meta: {
        unitAuth: true, // 添加登录验证（该页面需要登录）
        type: 2 //表示众筹菜单
      },
      component: cfProjectInfo,
    },

    {
      path: '/cfProAppropriation',
      name: 'cfProAppropriation',
      meta: {
        unitAuth: true, // 添加登录验证（该页面需要登录）
        type: 2 //表示众筹菜单
      },
      component: cfProAppropriation,
    },

    {
      path: '/cfProAppropriationDo1',
      name: 'cfProAppropriationDo1',
      meta: {
        unitAuth: true, // 添加登录验证（该页面需要登录）
        type: 2 //表示众筹菜单
      },
      component: cfProAppropriationDo1,
    },







    {
      path: '/cfProSubmitReport',
      name: 'cfProSubmitReport',
      meta: {
        unitAuth: true, // 添加登录验证（该页面需要登录）
        type: 2 //表示众筹菜单
      },
      component: cfProSubmitReport,
    },
    {
      path: '/cfProSubmitMedia',
      name: 'cfProSubmitMedia',
      meta: {
        unitAuth: true, // 添加登录验证（该页面需要登录）
        type: 2 //表示众筹菜单
      },
      component: cfProSubmitMedia,
    },
    {
      path: '/cfProApplyVisit',
      name: 'cfProApplyVisit',
      meta: {
        unitAuth: true, // 添加登录验证（该页面需要登录）
        type: 2 //表示众筹菜单
      },
      component: cfProApplyVisit,
    },
    // {
    //   path: '/cfProSubmitAgreement',
    //   name: 'cfProSubmitAgreement',
    //   meta: {
    //     unitAuth: true, // 添加登录验证（该页面需要登录）
    //     type: 2 //表示众筹菜单
    //   },
    //   component: cfProSubmitAgreement,
    // },
    {
      path: '/cfProApplyList',
      name: 'cfProApplyList',
      meta: {
        unitAuth: true, // 添加登录验证（该页面需要登录）
        type: 2 //表示众筹菜单
      },
      component: cfProApplyList,
    },
    // {
    //   path: '/cfProPaymentList',
    //   name: 'cfProPaymentList',
    //   meta: {
    //     unitAuth: true, // 添加登录验证（该页面需要登录）
    //     type: 2 //表示众筹菜单
    //   },
    //   component: cfProPaymentList,
    // },
    // {
    //   path: '/cfProPaymentAdd',
    //   name: 'cfProPaymentAdd',
    //   meta: {
    //     unitAuth: true, // 添加登录验证（该页面需要登录）
    //     type: 2 //表示众筹菜单
    //   },
    //   component: cfProPaymentAdd,
    // },
    // {
    //   path: '/cfProPaymentEdit',
    //   name: 'cfProPaymentEdit',
    //   meta: {
    //     unitAuth: true, // 添加登录验证（该页面需要登录）
    //     type: 2 //表示众筹菜单
    //   },
    //   component: cfProPaymentEdit,
    // },
    {
      path: '/report',
      name: 'report',
      meta: {
        unitAuth: true, // 添加登录验证（该页面需要登录）
        type: 1 //表示众筹菜单
      },
      component: report,
    },
    {
      path: '/reportExports',
      name: 'reportExports',
      meta: {
        unitAuth: true, // 添加登录验证（该页面需要登录）
        type: 2
      },
      component: reportExports,
    },
    {
      path: '/reportEdit',
      name: 'reportEdit',
      meta: {
        unitAuth: true, // 添加登录验证（该页面需要登录）
        type: 2
      },
      component: reportEdit,
    },


  ]
})




export default router
// 执行机构登录
const UNIT_LOGIN = '/unitLogin';
// 个人中心 ……
//路由全局守卫
router.beforeEach((to, from, next) => {
  if (to.matched.length === 0) {
    from.name ? next({
      name: from.name
    }) : next('/')
  }

  // if(to.path!='/friend'){
  //   db.post(db.config.getWebInfoUrl).then(res=>{
  //     if(res.data.ifclose==2){

  //       router.push({name: 'friend'});
  //       return  false
  //     }
  //   })    

  // }

  var timestamp = new Date().getTime();

  // 单位登录授权
  if (to.meta.unitAuth) {
    var unitAuth = sessionStorage.getItem("unitAuth");
    if (unitAuth) {
      unitAuth = JSON.parse(unitAuth)
      if (unitAuth.type == 1) {
        if (to.meta.type != 1) {
          sessionStorage.setItem('unitChannelName', 'hospitalComProjectList')
          next({
            path: 'hospitalComProjectList',
          })
        }
      } else if (unitAuth.type == 2) {
        if (to.meta.type != 2) {
          sessionStorage.setItem('unitChannelName', 'cfProjectList')
          next({
            path: 'cfProjectList',
          })
        }
      } else if (unitAuth.type == '' || !unitAuth.type) {
        alert('该用户权限异常，请联系负责人重新分配权限！')
        sessionStorage.removeItem("unitAuth");
      }
      // if ((Number(timestamp) - Number(unitAuth.timestamp)) / 1000 > 7200) {
      //   sessionStorage.removeItem("unitAuth");
      //   next({
      //     path: UNIT_LOGIN,
      //     query: {
      //       redirect: to.fullPath
      //     }
      //   })
      // }
    } else {
      next({
        path: UNIT_LOGIN,
        query: {
          redirect: to.fullPath
        } // 将跳转的路由path作为参数，登录成功后跳转到该路由
      })
    }
  }

  next();

})



// WEBPACK FOOTER //
// ./src/router/index.js